import config from "../config";

/**
 * Geocode an address using the Google Maps Geocoding API.
 * Returns { lat, lng } or throws if the response is not OK.
 */
export async function geocodeAddress(address) {
  const res = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${config.REACT_APP_GOOGLE_MAPS_API_KEY}`
  );
  const data = await res.json();

  if (data.status !== "OK" || !data.results || data.results.length === 0) {
    throw new Error(
      `Geocoding failed for "${address}": ${data.status}${data.error_message ? ` - ${data.error_message}` : ""}`
    );
  }

  return data.results[0].geometry.location;
}

/**
 * Get the IANA timezone ID for a given lat/lng at a specific time.
 * @param {number} lat
 * @param {number} lng
 * @param {number} timestampMs - timestamp in milliseconds
 * Returns the timeZoneId string or throws if the response is not OK.
 */
export async function getTimezone(lat, lng, timestampMs) {
  const timestamp = Math.floor(timestampMs / 1000);
  const res = await fetch(
    `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${config.REACT_APP_GOOGLE_MAPS_API_KEY}`
  );
  const data = await res.json();

  if (data.status !== "OK") {
    throw new Error(
      `Timezone lookup failed: ${data.status}${data.errorMessage ? ` - ${data.errorMessage}` : ""}`
    );
  }

  return data.timeZoneId;
}
